<template>
  <!-- -->
  <div class="table-data-2-show">
    <div class="table-data-container">
      <alone-image :src="imageList[0].itemImage" class="table-image"/>
      <alone-text-on-image :data="imageList[0]"/>
    </div>
    <div class="table-data-container">
      <alone-image :src="imageList[1].itemImage" class="table-image"/>
      <alone-text-on-image :data="imageList[1]"/>
    </div>


  </div>
</template>

<script>

import YqIcon from "@/components/YqIcon.vue";
import AloneImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneImage.vue";
import {watch} from "vue";
import AloneTextOnImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneTextOnImage.vue";

export default {
  props: {
    data: {default: () => {
        return {}
      }},
  },
  name: "",
  components: {
    AloneTextOnImage,
    YqIcon, AloneImage
  },
  data() {
    return {
      imageList: [],
    };
  },
  created() {
    this.init();
    watch(() => this.data, () => this.init())
  },
  methods: {
    init() {
      if (!this.data.componentData || !this.data.componentData.length) {
        this.imageList = [
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: ""},
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: ""},
        ];
      } else {
        this.imageList = this.data.componentData;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table-data-2-show {
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  background-color: #FFF;
  border-radius: 10px;
  .table-data-container{
    width: 315px;
    height: 200px;
    position: relative;
  }
  .table-image{

  }
}
</style>